export default "__VITE_ASSET__BTl07pV1__"